<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-card :bordered="false" >
        <a-row>
          <a-col :span="12">
            <div style="padding: 2px">
              <div class="two" style="float: left;" >
                <span :class="isSalesSelect === '1'?'isActive': ''" @click="handelSalesClick('1')" style="font-size: 14px">昨日</span>
                <span :class="isSalesSelect === '7'?'isActive': ''" @click="handelSalesClick('7')" style="font-size: 14px">近7日</span>
                <span :class="isSalesSelect === '30'?'isActive': ''" @click="handelSalesClick('30')" style="font-size: 14px">近30日</span>
                <span :class="isSalesSelect === '90'?'isActive': ''" @click="handelSalesClick('90')" style="font-size: 14px">近三月</span>
                <span :class="isSalesSelect === '365'?'isActive': ''" @click="handelSalesClick('365')" style="margin-right:10px; font-size: 14px">一年</span>
              </div>
              <a-range-picker v-model="saleDateRange" valueFormat="YYYY-MM-DD"  @change="salesDateChange"  size="default"/>
            </div>
            <div id="salesChart" style="height: 600px"></div>
          </a-col>
          <a-col :span="12">
            <div style="padding: 2px">
              <div class="two" style="float: left;" >
                <span :class="isCollectionSelect === '1'?'isActive': ''" @click="handelCollectionClick('1')" style="font-size: 14px">昨日</span>
                <span :class="isCollectionSelect === '7'?'isActive': ''" @click="handelCollectionClick('7')" style="font-size: 14px">近7日</span>
                <span :class="isCollectionSelect === '30'?'isActive': ''" @click="handelCollectionClick('30')" style="font-size: 14px">近30日</span>
                <span :class="isCollectionSelect === '90'?'isActive': ''" @click="handelCollectionClick('90')" style="font-size: 14px">近三月</span>
                <span :class="isCollectionSelect === '365'?'isActive': ''" @click="handelCollectionClick('365')" style="margin-right:10px; font-size: 14px">一年</span>
              </div>
              <a-range-picker  v-model="collectionDateRange" valueFormat="YYYY-MM-DD"  @change="collectionDateChange"  size="default"/>
            </div>
            <div id="collectionChart" style="height: 600px"></div>
          </a-col>
          <a-col :span="12">
            <div style="padding: 5px">
              <div class="two"  style="float: left;">
                <span :class="isCartSelect === '1'?'isActive': ''" @click="handelCartClick('1')">昨日</span>
                <span :class="isCartSelect === '7'?'isActive': ''" @click="handelCartClick('7')">近7日</span>
                <span :class="isCartSelect === '30'?'isActive': ''" @click="handelCartClick('30')" style="font-size: 14px">近30日</span>
                <span :class="isCartSelect === '90'?'isActive': ''" @click="handelCartClick('90')" style="font-size: 14px">近三月</span>
                <span :class="isCartSelect === '365'?'isActive': ''" @click="handelCartClick('365')" style="margin-right:10px; font-size: 14px">一年</span>
              </div>
              <a-range-picker  v-model="cartDateRange" valueFormat="YYYY-MM-DD"  @change="cartDateChange"  size="default"/>
            </div>
            <div id="cartChart" style="height: 600px"></div>
          </a-col>
        </a-row>
      </a-card>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {tableMixin} from '@/store/table-mixin'
import * as echarts from 'echarts'
import {goodsCart, goodsCollection, goodsSales} from "@/api/statistics/goods";
import moment from 'moment';

export default {
  name: 'goodsSta',
  components: {},
  mixins: [tableMixin],
  data() {
    return {
      activeKey: 1,
      saleDateRange: [],
      salesParam: {
        chartType: '1',
        startTime: undefined,
        endTime:undefined,
        sortField: 'salesNum',
        sortOrder: 'desc',
        pageNum: 1,
        pageSize: 10,
      },
      collectionDateRange: [],
      collectionParam: {
        chartType: '1',
        startTime: undefined,
        endTime:undefined,
        sortField: 'salesNum',
        sortOrder: 'desc',
        pageNum: 1,
        pageSize: 10,
      },
      cartDateRange: [],
      cartParam: {
        chartType: '1',
        startTime: undefined,
        endTime:undefined,
        sortField: 'salesNum',
        sortOrder: 'desc',
        pageNum: 1,
        pageSize: 10,

      },
      /*销售数据选择*/
      isSalesSelect: undefined,
      isCollectionSelect: undefined,
      isCartSelect: undefined,
    }
  },
  filters: {},
  created() {
  },
  mounted() {
    this.handelSalesClick("30")
    this.handelCartClick("30")
    this.handelCollectionClick("30")

  },
  computed: {},
  watch: {},
  methods: {
    moment,
    changeTab(index) {
      if (index == null) {
        index = undefined;
      }
      this.activeKey = index;
    },

    subMonth(num) {
      const newDate = new Date();
      newDate.setMonth(newDate.getMonth() - num);
      return newDate;
    },
    subDay(num) {
      return moment().add(-num, 'days');
    },

    salesDateChange(val) {
      this.salesParam.startTime = val[0] + ' 00:00:00';
      this.salesParam.endTime = val[1] + ' 23:59:59';
      this.drawSalesChart();
    },
    collectionDateChange(val) {
      this.collectionParam.startTime = val[0] + ' 00:00:00';
      this.collectionParam.endTime = val[1] + ' 23:59:59';
      this.drawCollectionChart();
    },
    cartDateChange(val) {
      this.cartParam.startTime = val[0] + ' 00:00:00';
      this.cartParam.endTime = val[1]+ ' 23:59:59';
      this.drawCartChart();
    },
    handelSalesClick(val) {
      this.isSalesSelect = val;
      this.salesParam.chartType = '1';
      let startDate = this.subDay(val).format('YYYY-MM-DD');
      let endDate = moment().format('YYYY-MM-DD');
      this.salesParam.startTime = startDate + " 00:00:00";
      this.salesParam.endTime = endDate + " 23:59:59";
      this.saleDateRange = []
      this.saleDateRange.push(startDate)
      this.saleDateRange.push(endDate)
      this.drawSalesChart();
    },
    handelCollectionClick(val) {
      this.isCollectionSelect = val;
      this.collectionParam.chartType = '1';
      let startDate = this.subDay(val).format('YYYY-MM-DD');
      let endDate = moment().format('YYYY-MM-DD');
      this.collectionParam.startTime = startDate + " 00:00:00";
      this.collectionParam.endTime = endDate + " 23:59:59";
      this.collectionDateRange = []
      this.collectionDateRange.push(startDate)
      this.collectionDateRange.push(endDate)
      this.drawCollectionChart();
    },
    handelCartClick: function (val) {
      this.isCartSelect = val;
      this.cartParam.chartType = '1';
      let cartStartDate = this.subDay(val).format('YYYY-MM-DD');
      let cartEndDate = moment().format('YYYY-MM-DD');
      this.cartParam.startTime = cartStartDate + " 00:00:00";
      this.cartParam.endTime = cartEndDate + " 23:59:59";
      this.cartDateRange = []
      this.cartDateRange.push(cartStartDate)
      this.cartDateRange.push(cartEndDate)
      this.drawCartChart();
    },
    drawSalesChart() {
      // // 添加
      var chartDom = document.getElementById("salesChart");
      var myChart = echarts.init(chartDom);
      var option;
      goodsSales(this.salesParam).then((res) => {
        if (res.code === "20001") {
          //y轴数据, 商品名称
          let yaxis = res.data.yyAxis;
          let xAxis = res.data.xxAxis;
          option = {
            title: {
              text: '商品销量排行榜'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {},
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
            },
            yAxis: {
              data: yaxis
            },
            series: [
              {
                name: '商品销量',
                type: 'bar',
                data: xAxis
              },
            ]
          };
          option && myChart.setOption(option);
        }
      });
    },
    drawCollectionChart() {
      // // 添加
      var chartDom = document.getElementById("collectionChart");
      var myChart = echarts.init(chartDom);
      var option;
      goodsCollection(this.collectionParam).then((res) => {
        if (res.code === "20001") {
          //y轴数据, 商品名称
          let yaxis = res.data.yyAxis;
          let xAxis = res.data.xxAxis;
          option = {
            title: {
              text: '商品收藏排行榜'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {},
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
            },
            yAxis: {
              data: yaxis
            },
            series: [
              {
                name: '商品收藏量',
                type: 'bar',
                data: xAxis
              },
            ]
          };
          option && myChart.setOption(option);
        }
      });
    },
    drawCartChart() {
      // // 添加
      var chartDom = document.getElementById("cartChart");
      var myChart = echarts.init(chartDom);
      var option;
      goodsCart(this.cartParam).then((res) => {
        if (res.code === "20001") {
          //y轴数据, 商品名称
          let yaxis = res.data.yyAxis;
          let xAxis = res.data.xxAxis;
          option = {
            title: {
              text: '商品加购量排行榜'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {},
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
            },
            yAxis: {
              data: yaxis
            },
            series: [
              {
                name: '商品加购量',
                type: 'bar',
                data: xAxis
              },
            ]
          };
          option && myChart.setOption(option);
        }
      });
    },
  }
}
</script>
<style lang="less" scoped>
.two {
  margin-left: 10px;
  margin-right: 10px;

  span {
    display: inline-block;
    line-height: 30px;
    width: 60px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #999999;
    // color: #1890ff;
  }

  span:nth-child(1) {
    border-radius: 6px 0 0 6px;
    border-right: none;

  }

  span:nth-child(2) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(3) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(4) {
    border-radius: 0 6px 6px 0;
    position: relative;
  }

  span:nth-child(4) .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
  }
}

.isActive {
  background: #1890ff;
  color: #ffffff !important;
  border: 1px solid #1890ff !important;
}

</style>
